import React from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
export default function SimpleDialog(props) {
    const { onClose, open, values, title } = props;

    const handleClose = () => {
        onClose();
    };

    const handleListItemClick = value => {
        onClose(value);
    };

    return (
        <Dialog
            onClose={handleClose}
            aria-labelledby="simple-dialog-title"
            open={open}
        >
            <DialogTitle id="simple-dialog-title">{title}</DialogTitle>
            <List>
                {values.map(value => (
                    <ListItem
                        button
                        onClick={() => handleListItemClick(value)}
                        key={value}
                    >
                        <ListItemText primary={value} />
                    </ListItem>
                ))}
            </List>
        </Dialog>
    );
}

SimpleDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    values: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/base/SimpleDialog.jsx